var React = require('react');

function App (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"tigerface-icons"),React.createElement("rect",{"x":"1.5","y":"4.91","width":"9.91","height":"4.95","key":1}),React.createElement("rect",{"x":"12.59","y":"4.91","width":"9.91","height":"7.31","key":2}),React.createElement("rect",{"x":"1.5","y":"11.27","width":"9.91","height":"7.82","key":3}),React.createElement("rect",{"x":"12.59","y":"13.56","width":"9.91","height":"5.53","key":4})]);
}

App.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = App;

App.default = App;
